import { z } from 'zod';

import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#bausparvertrag

	{
        "antragstellerIds": [ String ],
        "sparbeitragMonatlich": BigDecimal
    }


*/

export const schemaEuropaceUpdateBausparvertrag = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    sparbeitragMonatlich: z.optional(schemaBigDecimal),
});

export type SchemaEuropaceUpdateBausparvertrag = z.infer<typeof schemaEuropaceUpdateBausparvertrag>;
